// extracted by mini-css-extract-plugin
module.exports = {"sections":"sections_sections__myi1C"};